'use es6';

import keyMirror from 'react-utils/keyMirror';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
export const NavItemEnum = {
  SUITE: 'suite',
  BUNDLE: 'bundle',
  CRM: 'crm',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  CMS: 'cms',
  OPERATIONS: 'operations'
};
export const SidenavConfig = {
  [NavItemEnum.SUITE]: {
    id: NavItemEnum.SUITE,
    title: 'pricingPage.pages.products.tabs.crmSuite.tabTitle',
    mobileCategory: 'pricingPage.productCategories.bundles'
  },
  [NavItemEnum.MARKETING]: {
    id: NavItemEnum.MARKETING,
    title: 'pricingPage.pages.products.tabs.marketing.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.SALES]: {
    id: NavItemEnum.SALES,
    title: 'pricingPage.pages.products.tabs.sales.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.SERVICE]: {
    id: NavItemEnum.SERVICE,
    title: 'pricingPage.pages.products.tabs.service.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.CMS]: {
    id: NavItemEnum.CMS,
    title: 'pricingPage.pages.products.tabs.cmsHub.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.OPERATIONS]: {
    id: NavItemEnum.OPERATIONS,
    title: 'pricingPage.pages.products.tabs.operations.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.CRM]: {
    id: NavItemEnum.CRM,
    title: 'pricingPage.pages.products.tabs.crm.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [NavItemEnum.BUNDLE]: {
    id: NavItemEnum.BUNDLE,
    title: 'pricingPage.pages.bundle.tabTitle',
    mobileCategory: 'pricingPage.productCategories.bundles'
  }
};
export const TAB_IDS = keyMirror({
  starter: null,
  advanced: null
});
export const tabIdToProductLevels = {
  [TAB_IDS.starter]: [STARTER],
  [TAB_IDS.advanced]: [PROFESSIONAL, ENTERPRISE]
};